import * as React from 'react';
import CityStores from '@ui/scenes/CityStores';
import { Page } from '@ui/components';

const CityStoresPage = () => (
  <Page>
    <CityStores />
  </Page>
);

export default CityStoresPage;



// WEBPACK FOOTER //
// ./src/pages/CityStores/CityStores.tsx